import { render, staticRenderFns } from "./certificado.vue?vue&type=template&id=a904beec&scoped=true"
import script from "./certificado.vue?vue&type=script&lang=js"
export * from "./certificado.vue?vue&type=script&lang=js"
import style0 from "./certificado.vue?vue&type=style&index=0&id=a904beec&prod&lang=css"
import style1 from "./certificado.vue?vue&type=style&index=1&id=a904beec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a904beec",
  null
  
)

export default component.exports